import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, NgZone, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Router, ActivatedRoute, NavigationStart, NavigationEnd } from '@angular/router';
// ngrx store
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

// services
import { BookingService } from '../../services/booking.service';
import { EventsService } from '../../services/events.service';
import { AppStateService } from '../../../shared/services/app-state.service';
import { CopyService } from '../../../shared/services/app-copy.service';
import { PriceService } from '../../../booking/services/price.service';
import { BagItemsService } from '../../../shared/services/bagItems.service';
import { ErrorHandler } from '../../../shared/services/error-handler.service';
import { AirportCopyService } from '../../../shared/services/app-airport-copy.service';
import { DataStorageService } from '../../../shared/services/data-storage.service';
import { LoginService } from '../../../shared/services/login.service';

// models
import { AppState } from '../../models/app-state.interface';
import { ModalData } from '../../../shared/models/modal.interface';
import { UserInitState } from '../../../shared/models/user-reducer.interface';
// globals
import { ABC_PARTNERS, BAG_OPTIONS } from '../../../shared/globals';
import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';
import { take } from 'rxjs/operators';

declare var zE: any;
declare var ga: any;
declare var exponea: any;
declare var window: any;

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss'],
  animations: [
    trigger('Dropdown', [
      state('in', style({
        opacity: 1,
        'height': '100px',
        transform: 'translateY(0)'
      })),
      transition('void => *', [
        style({
          opacity: 0,
          'height': '0',
          transform: 'translateY(-10px)'
        }),
        animate(300, keyframes([
          style({
            'height': '100px',
            transform: 'translateY(0px)',
            offset: 0.75
          }),
          style({
            'height': '100px',
            transform: 'translateY(0px)',
            opacity: 1,
            offset: 1
          })
        ]))
      ]),
      transition('* => void', [
        animate(300, keyframes([
          style({
            opacity: 0,
            offset: 0.25
          }),
          style({
            'height': '0',
            transform: 'translateY(-10px)',
            offset: 1
          })
        ]))
      ])
    ])
  ]
})
export class OverviewComponent implements OnInit, OnDestroy {

  private _flightSubscription: Subscription;
  private _flightFinderSubscription: Subscription;
  private _bookingSubscription: Subscription;
  private _bookingStateSubscription: Subscription;
  private _d2dBookingSubscription: Subscription;
  private _bookingInitSubscription: Subscription;
  private _priceSubscription: Subscription;
  private _routeSubscription: Subscription;
  private _panelSubscription: Subscription;
  private _userLanguageSubscription: Subscription;
  private _serviceRemoveSubscription: Subscription;
  private _milesSubscription: Subscription;
  private _userLoggedInSubscription: Subscription;
  private _userLoggedOutSubscription: Subscription;
  private _hubDropSubscription: Subscription;
  private _booking;
  private _bookingState;
  private _currentRoute;
  private serviceToRemove: 'abc' | 'ccd';

  public currentPanel = 0;
  public bagsArr = BAG_OPTIONS;
  public hasManualFlightData = false;
  public hasFlightData = true;
  public dataLoaded = false;
  public flightDirection: Number;
  public flightData;
  public manualFlightData;
  public currentBooking;
  public bookingSectionComplete;
  public virtualBags;
  public bagItems = {};
  public flightFinalDestination = {
    airportCode: '',
    airportName: '',
    airportCityName: '',
    arrivalDate: ''
  };
  public timeslot;
  public bookingABC: boolean;
  public isAirportToAirport;
  public price;
  public premiumSurcharge;
  public oldPrice = null;
  public oldBags = 0;
  public oldPromo = null;
  public priceLoaded = false;
  public showPrice = false;
  public bookingType: string;
  public intervalTimer = null;
  public appCopy;
  public appAirportCopy;
  public copyLoaded: Boolean = false;
  public airportCopyLoaded: Boolean = false;
  public selectedLanguage = '';
  // We need to seperate arrival and departure bag items dropdown
  public languageCode = '';
  public toggleDropdown = true;
  public toggleDepartureDropdown = true;
  public toggleArrivalDropdown = true;

  public showDepartureDetails = true;
  public showArrivalDetails = true;

  public showReviewAndpayment = false;
  public isD2dService = false;
  public flightServiceAvailable;
  public d2dBookingState;
  public d2dBookingProgress = {};
  public outboundBooking;
  public inboundBooking;
  public bookingCount = 0;
  public inboundDiscountedPrice: any = 0;
  public outboundDiscountedPrice: any = 0;
  public priceLoading;
  public miles
  public milesDiscountedPrice: any = 0;
  public airlineName: string;
  public user;
  public screenSize;
  public isHubdropBooking = false;
  public selectPostOffice = null;
  public isFlybackBooking = false;
  public outboundAdditionBagPrice: any = '';
  public inboundAdditionBagPrice: any = '';

  constructor(
    private _appStore: Store<AppState>,
    private _bookingService: BookingService,
    private _eventsService: EventsService,
    private _priceService: PriceService,
    private _appStateService: AppStateService,
    private _copyService: CopyService,
    private _airportCopyService: AirportCopyService,
    private _ngZone: NgZone,
    @Inject(PLATFORM_ID) private platformId: Object,
    private _router: Router,
    private _route: ActivatedRoute,
    private _bagItemsService: BagItemsService,
    private _dataStorageService: DataStorageService,
    private _errorService: ErrorHandler,
    private _loginService: LoginService,
  ) { }

  ngOnInit() {

    this.screenSize = window.innerWidth;


    if (isPlatformBrowser(this.platformId)) {

      this._currentRoute = window.location.pathname.split('/')[2];
      this.showPriceSection();

      this._routeSubscription = this._router.events.subscribe(event => {
        if (event instanceof NavigationStart) {
          this._currentRoute = event.url.split('/')[2];
          this.showPriceSection();
        }
      });

      this._bookingInitSubscription = this._appStore.select('loadedStatusReducer')
        .subscribe((res: any) => {
          // if booking data has bookingLoaded
          // show template and subscribe to data
          this.priceLoaded = res.priceLoaded;
          if (res.currentBookingLoaded && !this.dataLoaded) {
            this.setDataSubscriptions();
            this.copyLoaded = res.copyLoaded;
            this.airportCopyLoaded = res.airportCopyLoaded;

            if (res.copyLoaded && res.airportCopyLoaded) {
              this.getCopy();
              this.getAirportCopy();
              this.dataLoaded = true;
            }

            if (res.copyLoaded && res.airportCopyLoaded && res.priceLoaded && res.currentBookingLoaded) {
              this.getD2dTotalPrice();
            }

            this.showDepartureDetails = this.bookingABC;
            this.showArrivalDetails = !this.bookingABC;

            const currentUrl = window.location.pathname.split('/')[2];

            this.showPrice = false;

            if (currentUrl === 'payment') {
              this.expandActiveBookingDetails();

              if (this.isMobileView()) {
                this.openOverviewDrawer();
              }
              this.showPrice = true;
            }

            if (currentUrl === 'upgrade-ccd' || currentUrl === 'upgrade-abc') {
              this.expandActiveBookingDetails();
            }
            this.isFlybackBooking = this.getState(this._appStore).flybackReducer.flybackBooking;
            this._userLanguageSubscription = this._appStore.select('copyReducer')
              .subscribe((res: any) => {
                this.selectedLanguage = res.language;
                this.languageCode = res.languageCode;
              })
          } else if (!res.currentBookingLoaded && this.dataLoaded) {
            this.dataLoaded = false;
            if (this._bookingSubscription) { this._bookingSubscription.unsubscribe(); }
            if (this._flightSubscription) { this._flightSubscription.unsubscribe(); }
            if (this._flightFinderSubscription) { this._flightFinderSubscription.unsubscribe(); }
            if (this._priceSubscription) { this._priceSubscription.unsubscribe(); }
            if (this._milesSubscription) { this._milesSubscription.unsubscribe(); }
            if (this._bookingStateSubscription) { this._bookingStateSubscription.unsubscribe(); }
            if (this._d2dBookingSubscription) { this._d2dBookingSubscription.unsubscribe(); }
          } else {
            return;
          }
        });

      this._serviceRemoveSubscription = this._errorService.removeD2dService$.subscribe(isServiceRemoved => {
        if (isServiceRemoved) {
          this.removeServiceHandler();
        }
      });


    }

    this.user = this.getState(this._appStore).userReducer;
    console.log(this.user, this.price)
    // // set user values on login and logout
    // this._userLoggedInSubscription = this._loginService.userSubject$.subscribe(res => {

    // });
    // this._userLoggedOutSubscription = this._loginService.userLoggedOut$.subscribe(res => {
    //   // this.hasSmsMarketingFlag = true;
    //   this.user = this.getState(this._appStore).userReducer;
    // });

  }

  updateBagItems(bags, type, bookingProduct) {
    if ((this.bookingABC && bookingProduct !== 'abc') || (!this.bookingABC && bookingProduct === 'abc')) {
      // upsell booking is added then don't let user to make any changes in that
      if (this.getState(this._appStore).d2dReducer.addBookingCount === 1) {
        const messageData = {
          type: 'info',
          title: '',
          text: 'Please complete this booking, you will be able to amend this booking from your account',
          sticky: false,
        };
        this._errorService.handleCustomInfo(messageData);
        return;
      }

      // navigate to other d2d booking
      let data;
      if (bookingProduct === 'abc') {
        data = { ...this.getState(this._appStore).d2dReducer.outboundBooking.bookingReducer.bookingDetails.bagItems };
      } else {
        data = { ...this.getState(this._appStore).d2dReducer.inboundBooking.bookingReducer.bookingDetails.bagItems };
      }

      data[type] = parseInt(bags, 10);
      if (this.currentPanel < 4) return;
      this._eventsService.goToBookingSwitcher(bookingProduct, 'payment', data);
      return;
    }

    this.bagItems[type] = parseInt(bags, 10);
    this._appStateService.setBagItems({ ...this.bagItems });
    this._bookingService.updateBagItems({ ...this.bagItems });
    this.updateBags(this._bagItemsService.getTotalItems(this.bagItems));
  }

  updateBags(bags) {
    this._appStateService.setVirtualBags(bags);
    this._bookingService.updateVirtualBags(bags);

    const currentUrl = window.location.pathname.split('/')[2];
    if (currentUrl === 'upgrade-ccd' || currentUrl === 'upgrade-abc') {
      // here we call calculate
      this._priceService.updatePriceBags(bags);
    }

    ga('set', 'page', '/abc/bags');
    ga('send', 'pageview');
  }

  private expandActiveBookingDetails() {
    if (this.isD2dService) {
      this.showDepartureDetails = true;
      this.showArrivalDetails = true;
      return;
    }

    if (this.bookingABC === undefined) {
      this.showDepartureDetails = true;
      this.showArrivalDetails = false;
      return;
    }

    this.showDepartureDetails = this.bookingABC;
    this.showArrivalDetails = !this.bookingABC;
  }

  showPriceSection() {
    this.showPrice = false;
    const hasPaymentPath = /payment/i.test(this._currentRoute);

    if (hasPaymentPath) {
      this.expandActiveBookingDetails();

      if (this.isMobileView()) {
        this.openOverviewDrawer();
      }
      this.showPrice = true;
    } else if (this._currentRoute === 'upgrade-ccd' || this._currentRoute === 'upgrade-abc') {
      this.expandActiveBookingDetails();
    }
  }

  private isMobileView(): boolean {
    return this.screenSize <= 1024;
  }

  handleChatClick() {
    zE.activate({ hideOnClose: true });
  }

  setDataSubscriptions() {
    this._bookingSubscription = this._appStore.select('currentBookingReducer')
      .subscribe((booking: any) => {
        this._booking = <AppState>booking;
        this.currentBooking = this._booking.currentBooking;
        this.bookingSectionComplete = this.currentBooking.bookingCompletion;
      });

    this._flightSubscription = this._appStore.select('flightReducer')
      .subscribe((flightData: any) => {

        this.flightData = flightData.flightDetails;

        if (
          Object.keys(this.flightData.flightResponse).length === 0 &&
          Object.keys(this.flightData.flightRequest).length === 0 &&
          Object.keys(this.flightData.flightManualDestination).length === 0) {
          this.hasFlightData = false;
          return;
        }

        if (Object.keys(this.flightData.flightManualDestination).length === 0) {


          this.flightFinalDestination = {
            airportCode: this.flightData.flightFinalDestination.airportCode,
            airportName: this.flightData.flightFinalDestination.airportName,
            airportCityName: this.flightData.flightFinalDestination.airportCityName,
            arrivalDate: this.flightData.flightResponse.flightStatusDetails[this.flightData.flightResponse.flightStatusDetails.length - 1].arrivalDateTimeDetails.scheduledDateTimeLocal
          };

        } else {
          this.hasManualFlightData = true;
          this.manualFlightData = this.flightData.flightManualDestination;
        }

      });

    this._bookingStateSubscription = this._appStore.select('bookingReducer')
      .subscribe((bookingState: any) => {
        this._bookingState = <AppState>bookingState;
        this.flightDirection = this._bookingState.bookingDetails.journeyLegDetails.length > 0
          ? this._bookingState.bookingDetails.journeyLegDetails[0].journeyDirection : null;
        this.bookingABC = this._bookingState.bookingDetails.bookingProduct === 'abc' ? true : false;
        this.isAirportToAirport = this._bookingState.bookingDetails.isAirportToAirport;
        this.timeslot = this._bookingState.bookingDetails.timeslot;
        this.virtualBags = this._bookingState.bookingDetails.virtualBagCount;
        this.bagItems = { ...this._bookingState.bookingDetails.bagItems };
        this.bookingType = this._bookingState.bookingDetails.bookingType;
        this.premiumSurcharge = this._bookingState.bookingDetails.premiumSurcharge;
        this.isD2dService = this._bookingState.bookingDetails.isD2dService;
      });

    this._priceSubscription = this._appStore.select('priceReducer')
      .subscribe((price: any) => {
        this.price = price.price;
        this.priceLoading = price.priceLoading;
      });

    this._milesSubscription = this._appStore.select('milesAndMoreReducer')
      .subscribe((miles) => {
        this.miles = miles;
        if (miles.milesRedeemed && miles.milesVerified?.status === 'AUTHORIZED') {
          this.milesDiscountedPrice = +(miles.payByMilesResponse.totalMilesSubmitted / miles.miles?.currencyRatio).toFixed(2)
        }
      });
    this._panelSubscription = this._appStore.select('updatePanelReducer')
      .subscribe((p: any) => {
        // stop error thrown if p is 0, redirect to first panel
        if (p === 0) { p = 1; }

        // + 1 becuase we took out flight details page
        this.currentPanel = p + 1;
      });

    this._d2dBookingSubscription = this._appStore.select('d2dReducer')
      .subscribe((res) => {
        const outboundBooking = res.outboundBooking;
        this.selectPostOffice = outboundBooking.hubDropReducer?.selectedPostOffice;
        if (this.selectPostOffice && outboundBooking.hubDropReducer?.selectedCollectionType === 'atPostOffice') {
          this.isHubdropBooking = true;
        } else {
          this.isHubdropBooking = false;
        }
        if (this._bookingState.bookingDetails.bookingType !== 'amend' && this.isD2dService) {
          this.d2dBookingState = res;
          this.bookingCount = res.bookingCount;
          const inboundBooking = res.inboundBooking;
          const outboundBooking = res.outboundBooking;

          if (!this.isObjectEmpty(outboundBooking)) {
            this.outboundBooking = {
              bagItems: outboundBooking.bookingReducer.bookingDetails.bagItems,
              virtualBags: outboundBooking.bookingReducer.bookingDetails.virtualBagCount,
              flightData: outboundBooking.flightReducer.flightDetails,
              currentBooking: outboundBooking.currentBookingReducer.currentBooking,
              timeslot: outboundBooking.bookingReducer.bookingDetails.timeslot,
              price: outboundBooking.priceReducer.price,
              isCompleted: outboundBooking.isCompleted,
              premiumSurcharge: outboundBooking.bookingReducer.bookingDetails.premiumSurcharge
            };
          }
          if (!this.isObjectEmpty(inboundBooking)) {
            this.inboundBooking = {
              bagItems: inboundBooking.bookingReducer.bookingDetails.bagItems,
              virtualBags: inboundBooking.bookingReducer.bookingDetails.virtualBagCount,
              flightData: inboundBooking.flightReducer.flightDetails,
              currentBooking: inboundBooking.currentBookingReducer.currentBooking,
              timeslot: inboundBooking.bookingReducer.bookingDetails.timeslot,
              price: inboundBooking.priceReducer.price,
              isCompleted: inboundBooking.isCompleted,
              premiumSurcharge: inboundBooking.bookingReducer.bookingDetails.premiumSurcharge
            };
          }

          this.flightServiceAvailable = res.flightDetails.flightProducts;
        }
        const airlineCode = this.getState(this._appStore).bookingReducer.bookingDetails.partnerAirlineCode || 'OTHER';
        this.airlineName = ABC_PARTNERS.find(partner => partner.code === airlineCode.toLocaleUpperCase())?.codeName;
      });
    // this.dataLoaded = true;
    this.outboundAdditionBagPrice = this.getState(this._appStore).flightFinderReducer.outboundAdditionBagPrice;
    this.inboundAdditionBagPrice = this.getState(this._appStore).flightFinderReducer.inboundAdditionBagPrice;
  };

  toggleOverviewDrawer() {
    if (isPlatformBrowser(this.platformId)) {
      const drawerClass = document.getElementsByClassName('booking-summary')[0].classList;
      drawerClass.toggle('is-open');
      drawerClass.toggle('is-closed');

      if (drawerClass.contains('is-open')) {
        document.querySelector('.icon-dropdown').innerHTML = 'chevron_up'
      } else {
        document.querySelector('.icon-dropdown').innerHTML = 'chevron_down'
      }
    }
  }

  openOverviewDrawer() {
    if (isPlatformBrowser(this.platformId)) {
      const drawerClass = document.getElementsByClassName('booking-summary')[0]?.classList;
      if (!drawerClass) { return; }
      drawerClass.add('is-open');
      drawerClass.remove('is-closed');

      const dropdownIcon = document.querySelector('.icon-dropdown');
      if (dropdownIcon) { dropdownIcon.innerHTML = 'chevron_up'; }
    }
  }

  toggleBagsDropdown(type?: string) {
    if (isPlatformBrowser(this.platformId)) {
      if (type === 'outbound') {
        this.toggleDepartureDropdown = !this.toggleDepartureDropdown;
        return;
      } else if (type === 'inbound') {
        this.toggleArrivalDropdown = !this.toggleArrivalDropdown;
        return;
      }
      this.toggleDropdown = !this.toggleDropdown
    }
  }

  onRemoveService(e, bookingType: 'abc' | 'ccd') {
    e.stopPropagation();
    const state = this.getState(this._appStore);

    this.serviceToRemove = bookingType;
    /**
     * check if user clicked on abc or ccd
     */
    const airport = bookingType === 'abc'
      ? state.flightReducer.flightDetails.flightResponse.flightStatusDetails[0].departureAirport
      : state.flightReducer.flightDetails.flightResponse.flightStatusDetails[state.flightReducer.flightDetails.flightResponse.flightStatusDetails.length - 1].arrivalAirport;

    const city = this.appAirportCopy[airport.airportCode]['airportCityName' + this.selectedLanguage]
    const modalData: ModalData = {
      type: 'default',
      modalType: 'removeService',
      title: this.appCopy.panelHeader['modalTitle' + this.selectedLanguage],
      content: this.appCopy.panelHeader['modalContent' + this.selectedLanguage].replace('%s', city),
      cancelButtonText: this.appCopy.panelHeader['cancelButton' + this.selectedLanguage],
      confirmButtonText: this.appCopy.panelHeader['deleteButton' + this.selectedLanguage],
      showLoader: false,
    };
    this._errorService.handleModal(modalData);
  }

  removeServiceHandler() {
    if (this.serviceToRemove === 'abc') {
      exponea.track('remove_booking', { booking_type: 'ABC', entry_source: this.getState(this._appStore).d2dReducer.entrySource || 'direct', });
    } else {
      exponea.track('remove_booking', { booking_type: 'CCD', entry_source: this.getState(this._appStore).d2dReducer.entrySource || 'direct', });
    }
    /**
     * if user removed the current booking remove it
     * and navigate user to other booking for payment
    */
    if (this.serviceToRemove === 'abc' && this.bookingABC) { // abc, abc
      const data = { serviceToRemove: 'abc' }
      this._eventsService.goToBookingSwitcher('ccd', 'payment', data);
    } else if (this.serviceToRemove === 'ccd' && !this.bookingABC) { // ccd, ccd
      const data = { serviceToRemove: 'ccd' }
      this._eventsService.goToBookingSwitcher('abc', 'payment', data);
    }
    /**
     * if user removed other booking remove that and continue
     * with current bookign
    */
    this._appStore.dispatch({ type: 'UPDATE_D2D_SERVICE', payload: false });
    this._appStore.dispatch({ type: 'CAN_AVAIL_D2D', payload: false });
    this.toggleDropdown = false;
    this.showDepartureDetails = false;
    this.toggleDepartureDropdown = false;
    this.showArrivalDetails = false;
    this.toggleArrivalDropdown = false;
    // call save data api
    this._dataStorageService.saveData();
  }

  getCopy() {
    const panelHeaderCopy = this._copyService.getCopyBySection(
      'OTHER',
      'overview',
      [this.flightDirection === 1 ? 'outbound' : 'inbound']
    );
    const panelHeaderCopy1 = this._copyService.getCopyBySection(
      'OTHER',
      'overview',
      ['outbound']
    );
    const panelHeaderCopy2 = this._copyService.getCopyBySection(
      'OTHER',
      'overview',
      ['inbound']
    );
    console.log('panelHeaderCopy', panelHeaderCopy);


    this.appCopy = {
      panelHeader: panelHeaderCopy[0],
      panelHeaderOutBound: panelHeaderCopy1[0],
      panelHeaderInBound: panelHeaderCopy2[0],
    };

  }

  getAirportCopy() {
    this.appAirportCopy = this._airportCopyService.getAirportsCopy();
  }

  // upgradeService() {
  //   this._appStore.dispatch({ type: 'UPDATE_TIMESLOT', payload: {
  //     start: '',
  //     end: '',
  //     date: '',
  //     id: '',
  //     airportTimeslotsWarning: false
  //   }});
  //   this._appStateService.upgradeProductToABC();
  // }

  isObjectEmpty(obj) {
    return obj && JSON.stringify(obj) === '{}';
  }

  goToPanel(panel: string) {
    this.toggleOverviewDrawer();
    if (this.isFlybackBooking && (panel === 'collection-time' || panel === 'delivery-time')) {
      exponea.track('flyback_timeslotamend', { entry_source: this.getState(this._appStore).d2dReducer.entrySource || 'direct', });
    }
    if (this.isD2dService) {
      const outboundPaths = ['collection-time', 'collection-location', 'collection-post-office'];
      const inboundPaths = ['delivery-time', 'delivery-location'];
      // upsell booking is added then don't let user to make any changes in that
      if (this.getState(this._appStore).d2dReducer.addBookingCount === 1 && ((outboundPaths.includes(panel) && !this.bookingABC) || (inboundPaths.includes(panel) && this.bookingABC))) {
        const messageData = {
          type: 'info',
          title: '',
          text: 'Please complete this booking, you will be able to amend this booking from your account',
          sticky: false,
        };
        this._errorService.handleCustomInfo(messageData);
        return;
      }

      if (outboundPaths.includes(panel) && !this.bookingABC) {
        this._eventsService.goToBookingSwitcher('abc', panel);
        return;
      }

      if (inboundPaths.includes(panel) && this.bookingABC) {
        this._eventsService.goToBookingSwitcher('ccd', panel);
        return;
      }
    }
    this._eventsService.goToPanelByPath(panel);
  }

  goToFlightResults() {
    // Update the data in the service
    const state = this.getState(this._appStore);
    const dataLinkSession = state.flightFinderReducer.dataLinkSession;
    if (dataLinkSession) {
      // Update the data in the service
      this._bookingService.updateDataVariable(true);
    } else {
      // Update the data in the service
      this._bookingService.updateDataVariable(false);
      this._router.navigate(['flight-finder/results']);
    }
  }

  toggleDetails(toggleType) {
    if (toggleType === 'abc') {
      this.showDepartureDetails = !this.showDepartureDetails;
    }

    if (toggleType === 'ccd') {
      this.showArrivalDetails = !this.showArrivalDetails;
    }
  }

  toggleShowpaymentAndReview() {
    this.showReviewAndpayment = !this.showReviewAndpayment;
  }

  getD2dDiscountPrice() {
    const state = this.getState(this._appStore);
    const isEmbeddedPromo = !!state.flightFinderReducer.promoFromUrl;

    if (this.bookingABC) {
      if (isEmbeddedPromo) {
        return (this.outboundBooking.price.discountAppliedMajor + (((this.inboundBooking.price.totalPrice.majorAmount * 100) / (100 - this.price.promotionRewardAmount)) * (this.price.promotionRewardAmount / 100))).toFixed(2);
      }
      else {
        return (this.outboundBooking.price.discountAppliedMajor + (this.price.promotionRewardAmount / 100 * this.inboundBooking.price.totalPrice.majorAmount)).toFixed(2);
      }
    } else {
      if (isEmbeddedPromo) {
        return (this.inboundBooking.price.discountAppliedMajor + (((this.outboundBooking.price.totalPrice.majorAmount * 100) / (100 - this.price.promotionRewardAmount)) * (this.price.promotionRewardAmount / 100))).toFixed(2);
      }
      else {
        return (this.inboundBooking.price.discountAppliedMajor + (this.price.promotionRewardAmount / 100 * this.outboundBooking.price.totalPrice.majorAmount)).toFixed(2);
      }
    }
  }
  getD2dTotalPrice() {
    const { outboundPrice, inboundPrice, totalD2dPrice } = this._bookingService.getD2dDiscountPrice(this.price);
    this.outboundDiscountedPrice = outboundPrice;
    this.inboundDiscountedPrice = inboundPrice;
    return totalD2dPrice;
  }

  getD2dOversizeitemSurchargePrice() {
    let outboundSurchargePrice = this.outboundBooking && this.outboundBooking.price && this.outboundBooking.price?.pricingResponse[0]?.pricingBreakdown?.oversizeSurchargePriceMajor ? this.outboundBooking.price.pricingResponse[0].pricingBreakdown.oversizeSurchargePriceMajor : 0;
    let inboundSurchargePrice = this.inboundBooking && this.inboundBooking.price && this.inboundBooking.price?.pricingResponse[0]?.pricingBreakdown?.oversizeSurchargePriceMajor ? this.inboundBooking.price.pricingResponse[0].pricingBreakdown.oversizeSurchargePriceMajor : 0;
    return outboundSurchargePrice + inboundSurchargePrice;
  }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
      .subscribe(s => state = s);
    return state;
  }

  getBasePriceByFlightDirection(priceObj) {
    const price = priceObj?.pricingResponse[0]?.pricingBreakdown;

    // let basePrice = price?.basePriceMajor ?? 0;
    // let slotAdjustedPriceMajor = price?.slotAdjustedPriceMajor ?? 0;
    // let productLocationPriceMajor = price?.productLocationPriceMajor ?? 0;
    // let totalStoragePriceMajor = price?.totalStoragePriceMajor ?? 0;
    // let additionalBagPrice = price?.additionalBagPriceMajor ?? 0;
    // let premiumSurchargePriceMajor = price?.premiumSurchargePriceMajor ?? 0;
    // let BagVolumeSurchargePrice = price?.BagVolumeSurchargePrice ?? 0;

    // let total = basePrice + slotAdjustedPriceMajor + productLocationPriceMajor + totalStoragePriceMajor + additionalBagPrice + BagVolumeSurchargePrice;
    // total = total + premiumSurchargePriceMajor; // if collection and deliverydate same

    return price?.totalPriceMajor; // this includes oversize item surcharge and excludes subsidy
  }

  openPriceBreakDown() {
    let discount = this.price.discountAppliedMajor;
    let currencySymbol = this.price.totalPrice.currencySymbol;
    let oversizeItemSurcharge = this.price.pricingResponse[0].pricingBreakdown.oversizeSurchargePriceMajor;

    let sbbDiscount = this.price.pricingResponse[0].pricingBreakdown.sbbSubsidyMajor;
    let sbbDiscountDep = 0;
    let sbbDiscountArrival = 0;

    let basePrice = this.getBasePriceByFlightDirection(this.price) + sbbDiscount - oversizeItemSurcharge;
    let basePriceDep = 0;
    let basePriceArrival = 0;

    let total = this.price.totalPrice.majorAmount;

    if (this.isD2dService) {
      discount = this.price.promotionRewardType === 1 ? this.price.discountAppliedMajor * 2 : this.getD2dDiscountPrice();
      currencySymbol = this.inboundBooking.price.totalPrice.currencySymbol;
      sbbDiscountDep = this.outboundBooking.price.pricingResponse[0].pricingBreakdown.sbbSubsidyMajor;
      sbbDiscountArrival = this.inboundBooking.price.pricingResponse[0].pricingBreakdown.sbbSubsidyMajor;

      let oversizeItemSurchargeDepPrice = this.outboundBooking && this.outboundBooking.price && this.outboundBooking.price?.pricingResponse[0]?.pricingBreakdown?.oversizeSurchargePriceMajor ? this.outboundBooking.price.pricingResponse[0].pricingBreakdown.oversizeSurchargePriceMajor : 0;
      let oversizeItemSurchargeArrivalPrice = this.inboundBooking && this.inboundBooking.price && this.inboundBooking.price?.pricingResponse[0]?.pricingBreakdown?.oversizeSurchargePriceMajor ? this.inboundBooking.price.pricingResponse[0].pricingBreakdown.oversizeSurchargePriceMajor : 0;

      basePriceDep = this.getBasePriceByFlightDirection(this.outboundBooking.price) + sbbDiscountDep - oversizeItemSurchargeDepPrice;
      basePriceArrival = this.getBasePriceByFlightDirection(this.inboundBooking.price) + sbbDiscountArrival - oversizeItemSurchargeArrivalPrice;

      oversizeItemSurcharge = oversizeItemSurchargeDepPrice + oversizeItemSurchargeArrivalPrice;
      total = this.getD2dTotalPrice();
    }

    const priceBreakdown = {
      isD2dService: this.isD2dService,
      flightDirection: this.flightDirection,
      basePrice,
      basePriceDep,
      basePriceArrival,
      currencySymbol: currencySymbol === "CHF" ? 'CHF ' : currencySymbol,
      oversizeItemSurcharge,
      sbbDiscount,
      sbbDiscountDep,
      sbbDiscountArrival,
      discount: discount,
      promotionRewardType: this.price.promotionRewardType,
      promoCodesApplied: this.price.promoCodesApplied,
      promotionRewardAmount: this.price.promotionRewardAmount,
      milesDiscountedPrice: this.milesDiscountedPrice,
      milesDiscountApplied: this.miles && this.miles.milesRedeemed && this.miles.canPayWithMiles && this.miles.milesVerified?.status === 'AUTHORIZED',
      total
    }

    const modalData: ModalData = {
      type: 'default',
      modalType: 'priceBreakdown',
      title: '',
      priceBreakdown,
      buttonText: this.appCopy.panelHeader['alertOKButton' + this.selectedLanguage],
      cancelButtonText: this.appCopy.panelHeader['alertCancelButton' + this.selectedLanguage],
    };

    this._errorService.handleModal(modalData);
  }

  ngOnDestroy() {
    if (this._bookingInitSubscription) { this._bookingInitSubscription.unsubscribe() };
    if (this._routeSubscription) { this._routeSubscription.unsubscribe() };
    if (this._bookingSubscription) { this._bookingSubscription.unsubscribe(); }
    if (this._flightSubscription) { this._flightSubscription.unsubscribe(); }
    if (this._priceSubscription) { this._priceSubscription.unsubscribe(); }
    if (this._milesSubscription) { this._milesSubscription.unsubscribe(); }
    if (this._bookingStateSubscription) { this._bookingStateSubscription.unsubscribe(); }
    if (this._d2dBookingSubscription) { this._d2dBookingSubscription.unsubscribe(); }
    if (this._panelSubscription) { this._panelSubscription.unsubscribe(); }
    if (this._userLanguageSubscription) { this._userLanguageSubscription.unsubscribe(); }
    if (this._serviceRemoveSubscription) { this._serviceRemoveSubscription.unsubscribe(); }
    if (this._userLoggedInSubscription) { this._userLoggedInSubscription.unsubscribe(); }
    if (this._userLoggedOutSubscription) { this._userLoggedOutSubscription.unsubscribe(); }
    if (this._hubDropSubscription) { this._hubDropSubscription.unsubscribe(); }
  }

}
